import ScSearchInput from "@/src/components/ui-kit/search-bar";
import ScTabs from "@/src/components/ui-kit/tabs";
import ToolbarCreateButton from "@/src/components/ui-kit/toolbar-create-button";
import { useTheme } from "@/src/styles/theme-provider";
import { Filter } from "iconsax-react-nativejs";
import { useTranslation } from "react-i18next";
import { Pressable, Text, View } from "react-native";

export const FEATURE_TABS = [
  "LABEL_TAB_MY_FEATURES",
  "LABEL_TAB_ALL_FEATURES",
] as const;
export type FeatureTab = (typeof FEATURE_TABS)[number];

type FeatureRequestHeaderProps = Readonly<{
  tabs: readonly FeatureTab[];
  activeTab: FeatureTab;
  onTabChange: (tab: FeatureTab) => void;
  search: string;
  onSearchChange: (text: string) => void;
  /** Rendered only when set — the "Created by" filter is super-admin only. */
  onCreatedByPress?: () => void;
  createdByCount: number;
  onCreatePress: () => void;
}>;

export default function FeatureRequestHeader({
  tabs,
  activeTab,
  onTabChange,
  search,
  onSearchChange,
  onCreatedByPress,
  createdByCount,
  onCreatePress,
}: FeatureRequestHeaderProps) {
  const { t } = useTranslation();
  const { themeVars } = useTheme();
  const filterActive = createdByCount > 0;

  return (
    <View className="flex-row flex-wrap items-center justify-between gap-4 px-6 py-4 bg-chalk rounded-2xl border border-ash-3">
      <ScTabs tabs={tabs} active={activeTab} onChange={onTabChange} />

      <View className="flex-row items-center flex-1 gap-3 justify-end min-w-[320px]">
        {onCreatedByPress && (
          <Pressable
            onPress={onCreatedByPress}
            className={`flex-row items-center gap-2 px-4 py-3 rounded-full border hover:bg-ash-3 ${
              filterActive ? "border-primary bg-primary-2" : "border-ash-3 bg-obsidian"
            }`}
          >
            <Filter
              size={16}
              color={
                themeVars[
                  filterActive ? "--color-primary-default" : "--color-ash-1"
                ] as string
              }
            />
            <Text
              className={`text-sm ${filterActive ? "text-primary font-medium" : "text-ash-1"}`}
            >
              {filterActive
                ? `${t("LABEL_CREATED_BY")} (${createdByCount})`
                : t("LABEL_CREATED_BY")}
            </Text>
          </Pressable>
        )}

        <ScSearchInput
          value={search}
          onChangeText={onSearchChange}
          placeholderKey="LABEL_SEARCH_REQUESTS"
          containerClassName="flex-1 max-w-[480px]"
        />

        <ToolbarCreateButton text="BTN_CREATE" onPress={onCreatePress} />
      </View>
    </View>
  );
}
